import { useState } from "react";
import { toast } from "sonner";
import { CalendarPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

// Manual fallback when the Calendly webhook isn't configured.
export const MarkBooked = ({ p, onDone }) => {
  const [open, setOpen] = useState(false);
  const [at, setAt] = useState("");
  if (!["scheduled", "sending", "replied", "completed", "draft"].includes(p.status)) return null;
  const save = async () => {
    if (!at) return toast.error("Pick the call date and time.");
    try { await api.post(`/admin/rcc/li/prospects/${p.id}/call-booked`, { call_at: new Date(at).toISOString() }); toast.success("Call booked. Sequence stopped and prep brief queued."); setOpen(false); onDone(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  if (!open) return <button onClick={() => setOpen(true)} className="text-zinc-500 hover:text-[#F3C649]" title="Mark call booked" data-testid={`li-book-${p.id}`}><CalendarPlus className="h-4 w-4" /></button>;
  return <div className="flex basis-full flex-wrap items-center gap-2 rounded-lg border border-[#D4AF37]/40 bg-[#D4AF37]/5 p-2" data-testid={`li-book-${p.id}-form`}>
    <span className="text-xs text-[#F3C649]">Call booked for</span>
    <Input type="datetime-local" value={at} onChange={(e) => setAt(e.target.value)} className="h-8 w-56 text-xs" data-testid={`li-book-${p.id}-at`} />
    <Button size="sm" onClick={save} className="h-8 bg-[#D4AF37] text-black" data-testid={`li-book-${p.id}-save`}>Save</Button>
    <Button size="sm" variant="ghost" onClick={() => setOpen(false)} className="h-8" data-testid={`li-book-${p.id}-cancel`}>Cancel</Button>
  </div>;
};
